<template>
  <div>
    <!-- update role modal -->
    <form @submit.prevent="promptUpdateRolePermission">
      <modal
        v-show="isUpdateRoleModalVisible"
        @close="closeUpdateRoleModal"
        :modalIsLarge="true"
        footer
      >
        <template v-slot:title>
          <h5>Update Role</h5>
        </template>
        <template v-slot:body>
          <div class="" v-if="role">
            <div class="form-group p-2">
              <label for="role_name" style="font-size:20px;font-weight:bold">{{
                role.name
              }}</label>

              <div class="row">
                <div
                  class="col-md-4 py-1 col-6"
                  v-for="perm in permissions"
                  :key="perm.id"
                  style="font-size:18px"
                >
                  <input
                    :disabled="!cpermissions.includes('create-update-role')"
                    type="checkbox"
                    class="form-check-input mr-2"
                    :value="perm.name"
                    v-model="permission"
                  />
                  <span class="text-capitalize pl-1">{{ perm.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <button
            v-if="cpermissions.includes('create-update-role')"
            type="submit"
            class="button"
            :disabled="updatingRolePermissionLoading"
          >
            <span class="custom-loader" v-if="updatingRolePermissionLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;"
                >Updating Role Permissions...</span
              >
            </span>
            <span v-else>Update Role Permission</span>
          </button>
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeUpdateRoleModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    <two-factor-prompt
      :visible="showTwoFaPrompt"
      :loading="twoFaLoading"
      description="Enter your authenticator code to update role permissions."
      submit-label="Update Role Permission"
      loading-text="Updating Role Permissions..."
      @close="closeTwoFaPrompt"
      @submit="confirmUpdateRolePermission"
    />

    <!--  -->

    <loader-ring v-if="getRolesLoading" class="loader-center"></loader-ring>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Roles</h1>
        </div>
      </div>
      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h4 class="card-title">Roles</h4>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="roles"
              :fields="fields"
              :items-per-page="100"
              pagination
              sorter
              tableFilter
            >
              <template #action="{item}">
                <td class="table--action-mobile">
                  <!-- <router-link class="button" :to="{name: 'Role', params: { slug: item.id }}">
                                        View
                                    </router-link> -->
                  <button
                    class="button btn-success"
                    style="background-color: #0bc681;"
                    @click="showUpdateModal(item)"
                  >
                    {{
                      cpermissions.includes("create-update-role")
                        ? "View/Update"
                        : "View"
                    }}
                    Roles
                  </button>
                </td>
              </template>
            </CDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CCard from "@/components/CCard";
import CDataTable from "@/components/CDataTable.vue";
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";
import { setTimeout } from "timers";
import { log } from "util";

const fields = ["name", "action"];

export default {
  name: "Roles",
  components: {
    CCard,
    CDataTable
  },
  computed: {
    cpermissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  data() {
    return {
      modalIsLarge: true,
      updatingRolePermissionLoading: false,
      isUpdateRoleModalVisible: false,
      small: true,
      fields,
      roles: [],
      role: null,
      permissions: [],
      new_filteredPermissions: [],
      permission: [],
      getRolesLoading: false,
      showTwoFaPrompt: false,
      twoFaLoading: false
    };
  },
  methods: {
    showUpdateRoleModal() {
      this.isUpdateRoleModalVisible = true;
    },
    closeUpdateRoleModal() {
      this.isUpdateRoleModalVisible = false;
      this.role = null;
      this.permission = null;
    },
    async getAllRoles() {
      try {
        this.getRolesLoading = true;
        const response = await ApiService.get("user/roles");
        console.log(response.data.data);
        this.getRolesLoading = false;
        this.roles = response.data.data;
        // console.log(response)
      } catch (error) {
        this.getRolesLoading = false;
        console.log(error.response);
      }
    },
    async getPermissions() {
      try {
        const response = await ApiService.get("user/permissions");

        this.permissions = response.data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
    showUpdateModal(item) {
      this.role = Object.assign({}, item);
      this.permission = this.role.permission;
      // console.log(item);
      // console.log(this.permission)
      this.showUpdateRoleModal();
    },
    promptUpdateRolePermission() {
      this.isUpdateRoleModalVisible = false;

      this.$nextTick(() => {
        this.showTwoFaPrompt = true;
      });
    },
    closeTwoFaPrompt(force = false) {
      if (this.twoFaLoading && !force) {
        return;
      }

      this.twoFaLoading = false;
      this.showTwoFaPrompt = false;
    },
    async confirmUpdateRolePermission(code) {
      let data = {
        permission: this.permission,
        code
      };

      try {
        this.twoFaLoading = true;
        const response = await ApiService.post(
          `user/update-role-permission/${this.role.id}`,
          data
        );
        this.twoFaLoading = false;
        this.closeTwoFaPrompt();
        this.closeUpdateRoleModal();
        this.permission = [];

        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });

        setTimeout(() => this.getAllRoles(), 3000);
      } catch (error) {
        this.closeTwoFaPrompt(true);
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    }
  },
  mounted() {
    this.getAllRoles();
    if (this.can("permissions")) {
      this.getPermissions();
    }
  }
};
</script>

<style></style>s
